import type { SurelcOnboardingData } from "../surelc/SurelcStatusLists.js";
import type { ViewerCapabilities } from "@aam/shared";

export interface SubmissionRow {
  id: string;
  status: string;
  imo: string;
  carriers: string[];
  createdAt: string;
  w9FilePath?: string | null;
  eftFilePath?: string | null;
}

export interface SubmissionSnapshot extends SubmissionRow {
  updatedAt: string;
  formData: Record<string, unknown>;
  canGenerateW9?: boolean;
  canGenerateEft?: boolean;
}

export interface ContractEvent {
  id: string;
  action: string;
  fromStatus: string | null;
  toStatus: string | null;
  notes: string | null;
  createdAt: string;
  actorUser: { id: string; email: string; role: string } | null;
}

export interface ProviderContract {
  id: string;
  carrier: string;
  imo: string;
  status: string;
  source: string;
  writingNumber: string | null;
  contractDate: string | null;
  notes: string | null;
  statusUpdatedAt: string;
  derivedFromLatestSubmission: boolean;
  manuallyMaintained: boolean;
  upstreamStatusName?: string | null;
  upstreamSource?: string | null;
  upstreamExternalId?: string | null;
  upstreamSyncedAt?: string | null;
  upstreamUplineName?: string | null;
  upstreamUplineNpn?: string | null;
  lastReconciledAt?: string | null;
  pinnedAt?: string | null;
  pinnedReason?: string | null;
  pinnedByUser?: { id: string; email: string; role: string } | null;
  lastModifiedByUser: { id: string; email: string; role: string } | null;
  events: ContractEvent[];
}

export interface AgentDetailData {
  id: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  displayName: string | null;
  profileSubmission: SubmissionSnapshot | null;
  latestSubmission: SubmissionSnapshot | null;
  submissions: SubmissionRow[];
  canLogin?: boolean;
  npn?: string | null;
  organization?: {
    id: string;
    slug: string;
    name: string;
    brandName: string;
  } | null;
  accessScope?: "OWN" | "DOWNLINE" | "ALL";
  commissionLevel?: string | null;
  compensationType?: string | null;
  archivedAt?: string | null;
  capabilities: ViewerCapabilities;
  upline?: {
    id: string;
    email: string;
    displayName: string;
    isStaff: boolean;
  } | null;
  surelc?: SurelcOnboardingData | null;
}

export const REDACTED_ENCRYPTED_VALUE = "__REDACTED_ENCRYPTED_FIELD__";

export const API_BASE = (() => {
  const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim();
  if (!raw) return "http://localhost:4000";
  return window.location.protocol === "https:" ? raw.replace(/^http:\/\//i, "https://") : raw;
})();
